import React, { useState } from 'react';
import { Repeat } from 'lucide-react';
import { useSidebar } from '../../../../context/CollapsedContext';

const FlipButton = ({ onClick, position, isFlipped, setIsFlipped }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const { collapsed, isHovered } = useSidebar();

  const handleClick = () => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    setIsFlipped(!isFlipped);
    
    if (onClick) onClick();
    
    setTimeout(() => setIsAnimating(false), 500);
  };

  return (
    <button
      onClick={handleClick}
      className={`absolute ${
        position === 'left' 
          ? (collapsed && !isHovered ? '-left-3' : '-left-1') 
          : (collapsed && !isHovered ? '-right-3' : '-right-1')
      } z-10 
        bg-white border border-gray-200 shadow-md rounded-lg p-2
        hover:bg-gray-50 hover:shadow-lg active:bg-gray-100
        transition-all duration-300 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50
        group`}
      aria-label={isFlipped ? "Revert flip" : "Do Flip"}
      disabled={isAnimating}
    >
      <div className={`relative ${collapsed && !isHovered ? 'h-3 w-3' : 'h-6 w-6'} flex items-center justify-center`}>
        {/* Main icon with flip animation */}
        <div className={`transition-all duration-500 ease-in-out ${ isFlipped ? 'rotate-180' : '' }`}>
          <Repeat className="h-5 w-5 text-red-600" />
        </div>
        
        {/* Active state indicator */}
        {isAnimating && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-ping h-4 w-4 rounded-full bg-red-200 opacity-75"></div>
          </div>
        )}
      </div>
      
      {/* Tooltip text */}
      <div className="absolute hidden group-hover:block bg-gray-800 text-white text-xs py-1 px-2 rounded 
        bottom-full mb-2 whitespace-nowrap left-1/2 transform -translate-x-1/2">
        {isFlipped ? "Revert flip" : "Do Flip"}
      </div>
    </button>
  );
};

export default FlipButton;
